import { render, staticRenderFns } from "./ProjectOnePagerList.vue?vue&type=template&id=6d54c0c1&scoped=true"
import script from "./ProjectOnePagerList.vue?vue&type=script&lang=js"
export * from "./ProjectOnePagerList.vue?vue&type=script&lang=js"
import style0 from "./ProjectOnePagerList.vue?vue&type=style&index=0&id=6d54c0c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d54c0c1",
  null
  
)

export default component.exports